// extracted by mini-css-extract-plugin
export default {"DoubleBorderScreenSkin":"Tep8cA","doubleBorderScreenSkin":"Tep8cA","bg":"MX3EN0","doubleBorderContainer":"utiGet"};